<template>
	<v-layout column class="container make-raport-wrapper">
		<v-form ref="reportform" v-model="reportvalid">
			<div v-if="haveReplayOrNormalRaport()" class="make-raport-title">
				{{ getStateWithParam("report_label") }}
			</div>
			<div>
				<div class="kategori-settings-wrapper">
					<v-radio-group
						class="radio-btn-wrapper"
						row
						v-model="post_form.category"
						:mandatory="false"
						:rules="[rules.categoryrequired]"
						no-gutters
					>
						<v-radio
							v-for="(rad, index) in radios_categ"
							:key="index + 100"
							class="kategori-radio-btn-item"
							:class="{
								'border-checked':
									post_form.category == rad.value,
							}"
							:label="getStateWithParam(rad.label)"
							:value="rad.value"
						></v-radio>
					</v-radio-group>
					<div
						v-if="post_form.category == 3"
						class="pb-2 pl-2 social-protection-label"
					>
						{{ getStateWithParam("social_protection_hint") }}
					</div>
					<div>
						<v-textarea
							class="makeraport-input"
							outline
							:label="getStateWithParam('report_address')"
							:hint="getStateWithParam('report_address_hint')"
							persistent-hint
							color="primary"
							v-model="post_form.streetName"
							append-icon="place"
							height="80"
							clear-icon="mdi-close-circle"
							clearable
							@click:append="getCurrentPosition()"
							:rules="[rules.addressrequired]"
						></v-textarea>
						<!-- <div class="d-flex address-options" style="margin: -10px 0 15px;">
							<div class="caption text-uppercase address-option-item"
								@click="getCurrentPosition()"
							>
								<v-icon class="address-option-icon">my_location</v-icon><span>{{getStateWithParam('report_address_my_location_lab')}}</span>
							</div>
							<div class="caption text-uppercase address-option-item" @click=" openmapdialog = true ">
								<v-icon class="address-option-icon">map</v-icon><span>{{getStateWithParam('report_address_map_lab')}}</span>
							</div>
						</div> -->
					</div>
					<div class="upload-img-wrapper">
						<div @click="takePicture()">
							<v-text-field
								class="makeraport-upload"
								readonly
								solo
								:label="getStateWithParam('upload')"
								color="primary"
								append-icon="image"
							></v-text-field>
						</div>
						<div
							class="uploaded-img-list"
							v-if="post_form.imgs.length > 0"
						>
							<div class="uploaded-img-gallery layout row wrap">
								<div
									class="flex xs4 uploaded-img-item"
									v-for="(item, index) in post_form.imgs"
									:key="index"
								>
									<div class="uploaded-img-item-inner">
										<v-img
											:src="item"
											aspect-ratio="1.7"
											contain
										></v-img>
										<!-- <img class="uploaded-img" :src="item" alt /> -->
										<v-icon
											class="upload-delete-img-icon"
											@click="
												removeFotoFromUploadedInApp(
													index
												)
											"
											sm
											color="white"
											>close</v-icon
										>
									</div>
								</div>
							</div>
						</div>
					</div>
					<v-textarea
						class="makeraport-input"
						outline
						name="input-7-4"
						:label="getStateWithParam('description_label')"
						v-model="post_form.description"
						:rules="[rules.descriptionrequired]"
					></v-textarea>
					<v-radio-group
						class="radio-btn-wrapper"
						row
						v-model="anonimitet"
						:mandatory="false"
					>
						<v-radio
							v-for="(anonim, index) in radios_anonim"
							:key="index + 200"
							class="kategori-radio-btn-item class-category-upper"
							:class="{
								'border-checked': anonimitet == anonim.value,
							}"
							:label="getStateWithParam(anonim.label)"
							:value="anonim.value"
						></v-radio>
					</v-radio-group>
					<div
						class="email-tel-wrapper"
						:class="{ 'email-tel-wrapper-on': anonimitet }"
					>
						<v-text-field
							class="makeraport-input"
							label="Email"
							color="primary"
							outline
							type="text"
							v-model="post_form.email"
							append-icon="email"
						></v-text-field>
						<v-text-field
							class="makeraport-input"
							label="Telefon"
							outline
							v-model="post_form.phone"
							type="number"
							append-icon="phone"
							color="primary"
						></v-text-field>
					</div>

					<v-btn
						@click="postRaport()"
						class="raporto-btn"
						:loading="loading3"
						:disabled="loading3"
					>
						{{ getStateWithParam("report_label") }}
						<v-icon right dark>send</v-icon>
					</v-btn>

					<div
						v-if="post_form.category == 3"
						class="pb-2 pl-2 social-protection-label"
					>
						{{ getStateWithParam("social_protection_urgent") }}
					</div>

					<div
						v-if="post_form.category == 3"
						class="d-flex justify-content-center"
						style="margin-bottom: 15px"
					>
						<div
							class="dashboard-item-bottom"
							@click="openNumberToCallPolice()"
						>
							<img
								class="color-white"
								src="@/assets/img/police.png"
								alt
								style="
									margin-right: 10px;
									width: 32px;
									height: 32px;
								"
							/>
							<span style="white-space: nowrap; color: #ffff">{{
								getStateWithParam("report_label_police")
							}}</span>
						</div>
						<div
							class="dashboard-item-bottom"
							@click="openNumberToCallEmergency()"
						>
							<img
								class="color-white"
								src="@/assets/img/emergency.png"
								alt
								style="
									margin-right: 10px;
									width: 32px;
									height: 32px;
								"
							/>
							<span style="white-space: nowrap; color: #ffff">{{
								getStateWithParam("report_label_emergency")
							}}</span>
						</div>
					</div>
				</div>
			</div>
		</v-form>
		<BaseToastModal :key="key_toast" v-if="show_toast" :message="message" />

		<v-snackbar
			class="snck-notification"
			v-model="fill_post_form"
			:timeout="timeout"
			>{{ getStateWithParam("fill_fields") }}</v-snackbar
		>
	</v-layout>
</template>

<script>
import info from "@/config/api/api_events/info.js";
import reports from "@/config/api/api_events/reports.js";
import native_capacitor from "@/config/js_helper/native_capacitor.js";

export default {
	name: "MakeReport",
	props: {
		raport_id_replay: {
			type: [String],
			default: "",
			required: false,
		},
	},
	data() {
		return {
			message: "report_sent",
			show_toast: false,
			key_toast: 8989,
			radios_categ: [
				{
					value: "0",
					label: "report_pollution",
				},
				{
					value: "1",
					label: "report_infrastructure",
				},
				{
					value: "2",
					label: "report_illegal_construction",
				},
				{
					value: "3",
					label: "report_social_protection",
				},
			],
			radios_anonim: [
				{
					value: false,
					label: "report_anonymous_label",
				},
				{
					value: true,
					label: "report_not_anonymous_label",
				},
			],
			anonimitet: false,
			loading3: false,
			showHopper: false,
			post_form: {
				user: "",
				imgs: [],
				category: null,
				reportIdReplay: this.raport_id_replay,
				description: "",
				lat: "",
				lon: "",
				streetName: "",
				anonymous: this.anonimitet ? 1 : 0,
				email: this.anonimitet ? "" : this.email,
				phone: this.anonimitet ? "" : this.phone,
			},
			fill_post_form: false,
			timeout: 2000,
			hooper_key: 5567,
			reportvalid: true,
			rules: {
				categoryrequired: (value) =>
					!!value || this.getStateWithParam("no_category_label"),
				addressrequired: (value) =>
					!!value || this.getStateWithParam("report_address_hint"),
				descriptionrequired: (value) =>
					!!value || this.getStateWithParam("no_description_label"),
				/* descriptionrequired: value => {
					return (value.length > 0 || this.post_form.imgs.length > 0) || this.getStateWithParam('no_description_label')
				}, */
				imagerequired: (value) => {
					return (
						this.post_form.imgs.length > 0 ||
						this.post_form.description.length > 0 ||
						this.getStateWithParam("no_description_label")
					);
				},
			},
		};
	},
	mounted() {
		if (this.$store.state.type_language == 1) this.radios = true;
		else this.radios = false;
		this.fillIdOfUser();
		this.$nextTick(function () {
			this.$store.state.active_loader = false;
		});
	},
	methods: {
		//method to call the police

		openNumberToCallPolice() {
			window.open("tel:129", "_system");
		},
		openNumberToCallEmergency() {
			window.open("tel:112", "_system");
		},

		takePicture() {
			//console.log('sss', this.post_form)
			try {
				if (this.post_form.imgs.length <= 3) {
					native_capacitor
						.getPhotoToUpload()
						.then((result) => {
							this.post_form.imgs.push(
								"data:image/jpg;base64," + result.base64String
							);
						})
						.catch((err) => {});
				}
				this.showHopper = true;
				this.hooper_key += 1;
			} catch (e) {
				console.log("error", e);
			}
		},
		async getCurrentPosition() {
			const permissions =
				await native_capacitor.checkLocationPermissions();
			if (permissions.location === "granted") {
				this.getPosition();
			} else {
				const platform = native_capacitor.Capacitor.getPlatform();
				if (platform === "web") {
					this.getPosition();
				} else {
					const confirm = await native_capacitor.showConfirm({
						title: this.getStateWithParam("location_off_title"),
						message: this.getStateWithParam(
							"locationaddr_off_message"
						),
						okButtonTitle: this.getStateWithParam("settings_btn"),
						cancelButtonTitle: this.getStateWithParam("close_btn"),
					});
					if (confirm.value) {
						//console.log('open settings');
						native_capacitor.openAppSettings();
					} else {
						//console.log('Dismissed');
					}
					//localStorage.setItem('locationalerts', true)
				}
			}
		},
		getPosition() {
			this.$store.state.active_loader = true;
			native_capacitor
				.getCurrentPosition()
				.then((result) => {
					//console.log(result);
					this.getPositionAddress(result);
				})
				.catch((err) => {
					this.$store.state.active_loader = false;
				});
		},
		getPositionAddress(position) {
			this.post_form.lat = position.coords.latitude;
			this.post_form.lon = position.coords.longitude;
			var string_with_lat_long =
				"&latlng=" + this.post_form.lat + "," + this.post_form.lon;

			//console.log(string_with_lat_long)
			//console.log(position)
			info.getAdressLiveTrafic(string_with_lat_long)
				.then((response) => {
					//console.log(response)
					if (
						response &&
						response.results[0] &&
						response.results[0].formatted_address
					) {
						this.post_form.streetName =
							response.results[0].formatted_address;
					} else if (
						response &&
						response.results[0] &&
						response.results[0].address_components &&
						response.results[0].address_components[0] &&
						response.results[0].address_components[0].long_name
					) {
						this.post_form.streetName =
							response.results[0].address_components[0].long_name;
					}
					this.$store.state.active_loader = false;
				})
				.catch((err) => {
					console.log(err);
					this.$store.state.active_loader = false;
				});
		},
		postRaport() {
			if (this.$refs.reportform.validate()) {
				this.$refs.reportform.validate();
				reports.postReport(this.post_form).then((response) => {
					this.key_toast += 1;
					this.show_toast = true;
					if (response.data.status) {
						this.post_form.imgs = [];
						this.post_form.category = null;
						this.post_form.reportIdReplay = this.raport_id_replay;
						this.post_form.description = "";
						this.post_form.lat = "";
						this.post_form.lon = "";
						this.post_form.streetName = "";
						this.message = "report_sent";
					} else {
						this.message = "report_failed";
					}
				});
			} else {
				this.fill_post_form = true;
			}
		},
		checkForPershkrimin() {
			return this.post_form.description != "";
		},
		fillIdOfUser() {
			this.post_form.user = localStorage.getItem("user_id");
		},
		removeFotoFromUploadedInApp: function (index) {
			this.$delete(this.post_form.imgs, index);
		},
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
		haveReplayOrNormalRaport() {
			var haveRaportId = this.raport_id_replay == "";
			haveRaportId
				? (this.post_form.reportIdReplay = "")
				: (this.post_form.reportIdReplay = this.raport_id_replay);

			return haveRaportId;
		},
	},
};
</script>

<style lang="scss" src="./MakeReport.scss"></style>
